import { AvailableIcons } from '@asn/icon';

export interface NavigationItem {
    label: string;
    iconName?: AvailableIcons;
    ariaLabel?: string;
    link?: string;
    badge?: number;
    children?: NavigationItem[];
    isOpen?: boolean;
    routeKey?: string;
    type: NavigationType;
}

export enum NavigationType {
    LINK_SAME_TAB = 'LINK_SAME_TAB',
    ROUTE_KEY = 'ROUTE_KEY',
    SEARCH = 'SEARCH',
    /** @deprecated Will be removed in A21 */
    LINK_ICON = 'LINK_ICON',
    /** @deprecated Will be removed in A21 */
    LINK_NEW_TAB = 'LINK_NEW_TAB',
    /** @deprecated Will be removed in A21 */
    BUTTON = 'BUTTON',
    /** @deprecated Will be removed in A21 */
    PARENT = 'PARENT',
    /** @deprecated Will be removed in A21 */
    PARENT_ICON = 'PARENT_ICON'
}

export interface ProfileMenu {
    name: string;
    subtitle: string;
    notifications?: number;
    groups: ProfileGroup[];
}

export interface ProfileGroup {
    items: ProfileMenuItem[];
    title?: string;
}

export interface ProfileMenuItem {
    icon: AvailableIcons;
    title: string;
    link?: string;
    routeKey?: string;
    subtitle?: string;
    notifications?: number;
}
